// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__GUYxs","label":"SetPasswdForm_label__1w7O2"};